module.exports = __webpack_public_path__ + "static/media/Nash Hussain.18683c8b.png";